/**
 * Стоимость в долларах, где мелкие суммы важны. Тариф хранения Bunny это
 * центы за гигабайт в месяц, и на двух знаках цена отдельного видео
 * превратилась бы в $0.00, поэтому суммы меньше десяти центов показываем с
 * четырьмя знаками.
 */
export function formatUsdCost(value: number): string {
  return value > 0 && value < 0.1
    ? `$${value.toFixed(4)}`
    : `$${value.toFixed(2)}`;
}
